export type ProjectDetailTab =
  | "uebersicht"
  | "bestellungen"
  | "fertigstellungen"
  | "angebot"
  | "dokumente"
  | "notizen";

export const PROJECT_DETAIL_TABS: Array<{
  id: ProjectDetailTab;
  label: string;
  /** Nur auf schmalen Viewports im Untermenü (Notizen stehen sonst rechts). */
  mobileOnly?: boolean;
  /** Nur für die Gruppe Büro sichtbar. */
  bueroOnly?: boolean;
}> = [
  { id: "uebersicht", label: "Übersicht" },
  { id: "bestellungen", label: "Bestellungen" },
  { id: "fertigstellungen", label: "Fertigstellungen" },
  { id: "angebot", label: "Angebot", bueroOnly: true },
  { id: "dokumente", label: "Dokumente", bueroOnly: true },
  { id: "notizen", label: "Notizen", mobileOnly: true },
];

export function parseProjectDetailTab(raw: string | null): ProjectDetailTab {
  if (
    raw === "bestellungen" ||
    raw === "fertigstellungen" ||
    raw === "angebot" ||
    raw === "dokumente" ||
    raw === "notizen"
  ) {
    return raw;
  }
  return "uebersicht";
}
